import {Injectable} from '@angular/core';
import {SETTINGS} from '../config/common.settings';
import {BehaviorSubject, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ExperienceService {
  pagedExperiences: any = {};
  onPagedExperiencesChange: Subject<any> = new BehaviorSubject({});

  experience: any = {};
  onExperienceChange: Subject<any> = new BehaviorSubject({});

  experienceByName: any;

  constructor(private http: HttpClient) {

  }

  getPagedExperiences(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/experiences/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.pagedExperiences = response[0];
            this.onPagedExperiencesChange.next(this.pagedExperiences);
            resolve(this.pagedExperiences);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getOneExperience(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!id) {
        this.onExperienceChange.next({});
        resolve({});
      } else {
        this.http.get(`${SETTINGS.BASE_API}/experiences/get/${id}`).subscribe({
          next: (response: any) => {
            this.experience = response;
            this.onExperienceChange.next(this.experience);
            resolve(this.experience);
          },
          error: (error: any) => {
            reject(error);
          },
        });
      }
    });
  }

  createExperience(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/experiences/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.experience = response;
            this.onExperienceChange.next(this.experience);
            resolve(this.experience);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createExperienceModal(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/experiences/iti/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.experience = response;
            this.onExperienceChange.next(this.experience);
            resolve(this.experience);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateExperience(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/experiences/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.experience = response;
            this.onExperienceChange.next(this.experience);
            resolve(this.experience);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateExperienceItin(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/experiences/update/itin`, payload)
        .subscribe({
          next: (response: any) => {
            this.experience = response;
            resolve(this.experience);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getExperiencesByName(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/experiences/get-experiences-by-name`, payload)
        .subscribe({
          next: (response: any) => {
            this.experienceByName = response;
            resolve(this.experienceByName);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getExperiencesByTitle(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/experiences/get-experiences-by-title`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
